import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '../../../../foundation/altzero_base/base/components/ui/button';
import { exportBatchMultiSite } from '../../services/batchMultiSiteExport';
import { NewBadge } from '../NewBadge';
import type { ReportBatchSummary } from '../../lib/reportBatchTypes';

type BatchMultiSiteExportButtonProps = {
  batch: Pick<ReportBatchSummary, 'id' | 'createdAt'>;
  /** Bill Runs' match tolerance; the default when not given. */
  tolerancePct?: number;
  onError: (message: string) => void;
};

/** "Export MultiSite XLSX" on a report batch row — shared by both batch panels. */
export const BatchMultiSiteExportButton = ({ batch, tolerancePct, onError }: BatchMultiSiteExportButtonProps) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const res = await exportBatchMultiSite(batch, tolerancePct);
      if (!res.success) onError(res.error ?? 'Could not export this batch');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button
      size="sm" variant="outline" disabled={busy} onClick={() => void run()}
      data-testid="report-batch-export-xlsx" className="gap-1"
      title="MultiSite Bill Validation Detail Report for the bills in this batch, with a Summary sheet"
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />}
      Export MultiSite XLSX <NewBadge />
    </Button>
  );
};
